import React from 'react'
import { JiraIntegrationPageProvider } from './jira-integration-page.provider'
import { JiraIntegrationPage } from './jira-integration-page'
import { CurrentOrganization } from '../../../current-organization'
import { getRouteParams } from '../../../route'

interface JiraIntegrationPageProps {
  readonly currentOrganization: CurrentOrganization
}

export const JiraIntegrationIndex = ({
  currentOrganization: { organizationUuid }
}: JiraIntegrationPageProps) => {
  const routeParams = getRouteParams()
  const isEdit = routeParams.length === 5
  return (
    <JiraIntegrationPageProvider
      state={{
        isEdit,
        organizationUuid,
        bugtrackerId: isEdit ? Number(routeParams[4]) : undefined
      }}
    >
      <JiraIntegrationPage />
    </JiraIntegrationPageProvider>
  )
}
